import { Injectable } from '@angular/core';
import { Observable, Subject, Subscription, timer } from 'rxjs';
import { INDRAApiService } from './api.indra.service';
import { URL_SESSION_RENEW } from '@ibe.config';

@Injectable({
	providedIn: 'root'
})
export class TimeoutSvcService {
	private _count = 0;
	private _timeoutMilliseconds = 480000; // 8 minutes
	private timerSubscription: Subscription;
	private _timer: Observable<number>;
	private resetOnTrigger = false;
	public timeoutExpired: Subject<number> = new Subject<number>();

	skipRenewSession$: Subject<boolean> = new Subject<boolean>();
	isOtherAPILoading$: Subject<boolean> = new Subject<boolean>();

	private timeoutExtension = 0;
	private sessionTimeoutTimeRemainingInSeconds = null;
	private sessionExtendIntervalInSeconds = null;
	public renewLimitReached: boolean = false

	constructor(
		private api: INDRAApiService
	) {
	}

	private setSubscription() {
		this._timer = timer(this.timeoutExtension ? this.timeoutExtension : this._timeoutMilliseconds);
		this.timerSubscription = this._timer.subscribe(n => {
			this.timeoutExtension = 0; // reset timeoutExtension
			this.timerComplete(n);
		});
	}


	public startTimer() {
		this.stopTimer();
		this.setSubscription();
	}

	public stopTimer() {
		if (this.timerSubscription) {
			this.timerSubscription.unsubscribe();
		}
	}

	public resetTimer() {
		this.startTimer();
	}

	private timerComplete(n: number) {
		this.timeoutExpired.next(++this._count);

		if (this.resetOnTrigger) {
			this.startTimer();
		}
	}

	public sessionRenew() {
		return this.api.INDRA_post<{renewLimitReached: boolean}>(URL_SESSION_RENEW, {});
	}

	public sessionDelete() {
		return this.api.INDRA_delete<{}>(URL_SESSION_RENEW, {});
	}

	// call this to avoid parallel calls with /renew
	// by extending timer by 1 minute
	public INDRA_extendTimer() {
		this.timeoutExtension = 60000; // 1 minute
		this.resetTimer();
	}

  public INDRA_setSessionTimeoutInSeconds(value: number) {
    this._timeoutMilliseconds = value * 1000; // multiply by 1000 for ms
    this.startTimer();
  }

  public INDRA_setSessionTimeoutTimeRemainingInSeconds(value: number) {
    this.sessionTimeoutTimeRemainingInSeconds = value;
  }

  public INDRA_getSessionTimeoutTimeRemainingInSeconds(): number {
    return this.sessionTimeoutTimeRemainingInSeconds;
  }

  public INDRA_setSessionExtendIntervalInSeconds(value: number) {
	this.sessionExtendIntervalInSeconds = value;
  }

  public INDRA_getSessionExtendIntervalInSeconds() {
	return this.sessionExtendIntervalInSeconds;
  }
 
}
